<template>
  <div class="no-permission">
    <h2>Access Denied</h2>
    <p>You don't have permission to access dashboard page.</p>
  </div>
</template>

<script>
export default {
}
</script>